export class TextMapWorkerWrapper {
    private worker: Worker;
    private id = 0;
    private messages = new Map<number, (event: MessageEvent<any>) => void>();

    constructor() {
        this.worker = new Worker(new URL('../epub-utils/text-map.worker.ts', import.meta.url), { type: 'module' });
        this.worker.onmessage = async (event) => {
            if (event.data.status === 'terminated') {
                this.messages.clear();
                this.worker.terminate();
            }
            const { id } = event.data;
            const callback = this.messages.get(id);
            if (callback) {
                callback(event);
                this.messages.delete(id);
            } else {
                console.warn(`No callback found for message id: ${id} (${event.data})`);
            }
        };
    }

    postMessage(message: any, callback: (event: MessageEvent<any>) => void): void {
        this.id++;
        this.messages.set(this.id, callback);
        this.worker.postMessage({...message, id: this.id });
    }

    terminate(): void {
        this.worker.postMessage({ action: 'terminate' });
    }
}